<template>
	<nav
		:aria-label="ariaLabel ? ariaLabel : $t('vertical-navigation.side-menu')"
		class="vertical-navigation"
	>
		<component
			:is="button.link ? 'helio-link' : 'button'"
			v-for="(button, index) in validButtons"
			:key="index"
			:class="{ 'vertical-navigation__button--active' : button.active }"
			class="vertical-navigation__button"
			data-cy="vertical-navigation-button"
			:link="button.link"
			@click="handleClick(button.value)"
		>
			<helio-icon
				v-if="button.iconToken"
				:token="button.iconToken"
				:weight="button.iconWeight ? button.iconWeight : 'regular'"
			/>

			{{ button.title }}

			<span
				v-if="button.notifications"
				class="vertical-navigation__notification-count"
			>
				<helio-notification-count
					:count="button.notifications.count ? button.notifications.count : 0"
					:count-limit="button.notifications.limit ? button.notifications.limit : 99"
					type="number"
					:aria-label="$t('notification-count.aria-label')"
				/>
			</span>

			<span
				v-if="button.badge && button.badge.text"
				class="vertical-navigation__badge"
			>
				<helio-badge :color="button.badge.color">
					<template>
						<helio-icon
							v-if="button.badge.icon"
							:color="button.badge.icon.color"
							:token="button.badge.icon.token"
							:weight="button.badge.icon.weight"
						/>
						<span>
							{{ button.badge.text }}
						</span>
					</template>
				</helio-badge>
			</span>
		</component>
	</nav>
</template>

<script>
import Icon from '../icon/Icon.vue';
import Link from '../link/Link.vue';
import NotificationCount from '../notification-count/NotificationCount.vue';

export default {
	name: 'VerticalNavigation',

	components: {
		'helio-icon': Icon,
		'helio-link': Link,
		'helio-notification-count': NotificationCount,
	},

	props: {
		ariaLabel: {
			type: String,
			required: false,
			default: null,
			description: 'Supplies an aria-label for the Vertical Navigation component. If this prop isn\'t passed, a default aria-label of "Sous-menu"/"Sub menu" will be used.',
		},

		buttons: {
			type: Array,
			required: true,
			validator: ((buttons) => {
				let passed = true;

				buttons.forEach((button) => {
					const buttonHasTitle = typeof button.title === 'string';
					const buttonHasValue = typeof button.value === 'string';
					const buttonHasLink = button.link;

					// Each object in the buttons array must include a
					// 'value' and a 'title' key/value pair.
					if (!buttonHasTitle
						|| (!buttonHasValue && !buttonHasLink)) {
						passed = false;
					}
				});

				return passed;
			}),
			description: 'Supplies data for each option that will appear in the VerticalNavigation',
		},
	},

	computed: {
		validButtons() {
			return this.buttons.filter(button => (button.title && (button.value || button.link)));
		},
	},

	methods: {
		handleClick(value) {
			this.$emit('click', value);
		},
	},
};
</script>

<style lang="scss" src="./vertical-navigation.scss" />
